const theme = {
  font: {
    family:
      "'Chivo', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    sizes: {
      xsmall: '1.2rem',
      small: '1.4rem',
      medium: '1.6rem',
      large: '1.8rem',
      xlarge: '2.6rem',
      xxlarge: '6.6rem'
    }
  },
  colors: {
    primary: '#484D5C',
    secondary: '#FFCE00',
    white: '#c0ccd4',
    grayDark: '#2e313a',
    gray: '#A8B3BC'
  },
  spacings: {
    xxsmall: '0.8rem',
    xsmall: '1.6rem',
    small: '2.4rem',
    medium: '3.2rem',
    large: '4.0rem',
    xlarge: '4.8rem',
    xxlarge: '5.6rem'
  }
}

export default theme
